import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './styles';
import premium from './premium.png';

const NoAccess = ({ isMobile }) => {
  return (
    <div
      style={
        isMobile
          ? styles.containerMobile
          : {
              ...styles.container,
              marginLeft: window.innerWidth > 2000 ? 'auto' : '5%',
              width: window.innerWidth > 2000 ? '1600px' : '',
              marginRight: window.innerWidth > 2000 ? 'auto' : '',
            }
      }>
      <div>
        <h2 style={styles.headingText}>Access Denied.</h2>
        <div style={{ width: '250px' }}>
          <img height='100%' width='100%' src={premium} alt="" />
        </div>
      </div>
    </div>
  );
};

export default withRouter(NoAccess);



// WEBPACK FOOTER //
// ./src/Pages/NoAccess/index.js